export default "__VITE_PUBLIC_ASSET__b242d681__"